import React from 'react';
import { Link } from 'react-router-dom';
import heroBg from '../assets/images/hero-bg.jpg';
import '../styles/Hero.css';

const Hero = () => {
  return (
    <section className="hero" style={{ backgroundImage: `url(${heroBg})` }}>
      <div className="hero-overlay">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Professional Notary Services in Federal Way</h1>
            <p className="hero-subtitle">
              Fast, reliable, and convenient notarization services for all your legal documents
            </p>
            <div className="hero-buttons">
              <Link to="/online-notarization" className="btn btn-primary">
                Online Notarization
              </Link>
              <a href="tel:2065664676" className="btn btn-secondary">
                Call Now: (206) 566-4676
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;